import useSWRImmutable from 'swr/immutable'
import { AxiosError } from 'axios'
import { AxiosBackend } from '../../service/HTTP/AxiosInstance'
import { VimeoVideoDetails } from './interface'

import { vimeoVideoDetailsSchema } from './vimeoVideoDetailsSchema'

interface UseVimeoVideoDetails {
  vimeoVideoDetails: VimeoVideoDetails[]
  error: AxiosError
  isLoading: boolean
}

export const getVimeoVideoDetails = () =>
  AxiosBackend.get<unknown>('/dictionary/vimeo-video-details')
export const useVimeoVideoDetails = (): UseVimeoVideoDetails => {
  const { data, error, isLoading } = useSWRImmutable(
    'vimeo_video_ids',
    getVimeoVideoDetails
  )

  const hookData = {
    vimeoVideoDetails: [],
    error,
    isLoading
  }

  if (isLoading || error) {
    return hookData
  }

  try {
    const response: { vimeoIds: VimeoVideoDetails[] } =
      vimeoVideoDetailsSchema.parse(data?.data)

    return {
      ...hookData,
      vimeoVideoDetails: response.vimeoIds
    }
  } catch {
    return {
      ...hookData,
      vimeoVideoDetails: []
    }
  }
}
